export interface ResumoContent {
	labelPeople: string;
	labelProducts: string;
	labelBeer: string;
	labelOperationTime: string;
}

export const resumoContent: ResumoContent = {
	labelPeople: "Pessoas passaram pelos seus eventos!",
	labelProducts: "Produtos foram vendidos!",
	labelBeer: "Litros de cerveja foram vendidos!",
	labelOperationTime: "Tempo de operação acumulado em minutos!",
};

export type Category = "people" | "products" | "beer" | "operationTime";

export function getLabelByCategory(category: Category): string {
	switch (category) {
		case "people":
			return resumoContent.labelPeople;
		case "products":
			return resumoContent.labelProducts;
		case "beer":
			return resumoContent.labelBeer;
		case "operationTime":
			return resumoContent.labelOperationTime;
	}
}
